import { useContext, useEffect } from 'react';
import FirebaseContext from 'components/Firebase/context';
import { useUser } from './hooks';
import { getDocs } from 'utils';
import { SetterOrUpdater, useRecoilState } from 'recoil';
import { Collection, collectionState } from 'atoms/collection';

export function useCollection(): [
  Collection | null,
  SetterOrUpdater<Collection | null>,
] {
  const user = useUser();
  const [collection, setCollection] = useRecoilState(collectionState);
  const { firebase }: any = useContext(FirebaseContext);

  useEffect(() => {
    if (collection || !user?.uid) return;

    async function fetchCollection() {
      const db = firebase.firestore();
      const query = db
        .collection('collections')
        .where('owner', '==', user?.uid);
      const snapshot = await query.get();

      return getDocs(snapshot).pop();
    }

    fetchCollection().then((c) => {
      setCollection(c);
    });
  }, [collection, user, firebase, setCollection]);

  return [collection, setCollection];
}
